module.exports = __webpack_public_path__ + "static/media/eng.eb5f52f4.svg";